import { useState, useEffect } from "react";
import DropdownMenu from "@excalidraw/excalidraw/components/dropdownMenu/DropdownMenu";
import { templateIcon } from "@excalidraw/excalidraw/components/icons";
import {
  restoreElements,
  restoreAppState,
} from "@excalidraw/excalidraw/data/restore";

import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

interface TemplateEntry {
  name: string;
  file: string;
}

export const TemplateMenu = ({
  excalidrawAPI,
}: {
  excalidrawAPI: ExcalidrawImperativeAPI | null;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [templates, setTemplates] = useState<TemplateEntry[]>([]);

  useEffect(() => {
    fetch("/templates/manifest.json")
      .then((res) => res.json())
      .then(setTemplates)
      .catch(() => setTemplates([]));
  }, []);

  const loadTemplate = async (file: string) => {
    if (!excalidrawAPI) {
      return;
    }
    const res = await fetch(`/templates/${file}`);
    const json = await res.json();
    excalidrawAPI.updateScene({
      elements: restoreElements(json.elements, null, {
        repairBindings: true,
      }),
      appState: restoreAppState(json.appState, excalidrawAPI.getAppState()),
    });
  };

  if (!templates.length) {
    return null;
  }

  return (
    <DropdownMenu open={isOpen}>
      <DropdownMenu.Trigger
        className="App-toolbar__extra-tools-trigger"
        onToggle={() => setIsOpen((o) => !o)}
        title="Vorlagen"
      >
        {templateIcon}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        onClickOutside={() => setIsOpen(false)}
        onSelect={() => setIsOpen(false)}
        className="App-toolbar__extra-tools-dropdown"
      >
        {templates.map((template) => (
          <DropdownMenu.Item
            key={template.file}
            icon={templateIcon}
            onSelect={() => loadTemplate(template.file)}
          >
            {template.name}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
